import * as React from 'react';
import { Box, styled } from '@leagueplatform/genesis-core';
import type { FlatDataPoint, ParentId } from '@web-config-app/core';
import type { PassIdFunction } from './data-point-radio-item.component';
import { DataPointItem } from './data-point-item.component';

const StyledNavItem = styled('li', {
  padding: '$half 0',
  borderBottomColor: '$onSurfaceBorderSubdued',
  borderBottomStyle: 'solid',
  borderBottomWidth: '$thin',
  '&:last-child': {
    borderBottom: 'none',
  },
});

export interface SelectDataPointProps {
  containerId: string;
  dataPoints: FlatDataPoint[];
  labelledBy: string;
  onNavigate: PassIdFunction;
  onSelectItem: PassIdFunction;
  selectedDataPoint?: ParentId;
  mode?: 'radio' | 'copy';
}

export const SelectDataPoint = ({
  containerId,
  dataPoints,
  labelledBy,
  onNavigate,
  onSelectItem,
  selectedDataPoint,
  mode = 'radio',
}: SelectDataPointProps) => (
  <Box
    aria-labelledby={labelledBy}
    as="ul"
    css={{ width: '100%', margin: '$one 0 $two' }}
    id={containerId}
    tabIndex={-1}
  >
    {dataPoints.map((dataPoint, index) => {
      const itemId = dataPoint.id || `item_${index}`;
      return (
        <StyledNavItem key={itemId}>
          <DataPointItem
            dataPoint={dataPoint}
            index={index}
            mode={mode}
            selectedDataPoint={selectedDataPoint}
            onNavigate={onNavigate}
            onSelectItem={onSelectItem}
          />
        </StyledNavItem>
      );
    })}
  </Box>
);
